<h2 class="step-title is-size-4-mobile">Please re-enter your phone number.</h2>
<h3>{{subtext}}</h3>
<div class="field">
  <div class="control">
    @if (!inputModeTest) {
      <input
        class="input is-large"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
        type="text" placeholder="(XXX) XXX-XXXX" formControlName="phone_number" [imask]="phoneMask" #phone (change)="snap()">
    }
    @if (inputModeTest) {
      <input
        inputmode="tel"
        class="input is-large"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
        type="text" placeholder="(XXX) XXX-XXXX" formControlName="phone_number" [imask]="phoneMask" #phone (change)="snap()">
    }
  </div>

  @if (controls[0].touched && controls[0].errors) {
    <div class="help is-danger has-text-left">
      @if (controls[0].errors.required) {
        <p>Phone Number is required.</p>
      }
      @if (controls[0].errors.pattern) {
        <p>Invalid Phone Number.</p>
      }
    </div>
  }
</div>

<div class="field checkboxes">
  <div class="control has-text-centered">
    <label class="checkbox">
      <input type="checkbox" formControlName="sms" (change)="snap()">
      Prefers text
    </label>
  </div>
  <div class="control has-text-centered">
    <label class="checkbox">
      <input type="checkbox" formControlName="email_preference" (change)="snap()">
      Prefers email
    </label>
  </div>
  <div class="control has-text-centered">
    <label class="checkbox">
      <input type="checkbox" formControlName="prefers_spanish" (change)="snap()">
      Prefers Spanish
    </label>
  </div>
</div>


<button class="button continue is-large has-shadow-small" (click)="submit()">
  View My Rates
  <i class="fas fa-chevron-right"></i>
</button>
<p class="tcpa is-size-7 has-text-grey-dark has-text-left">
  <input type="hidden" id="leadid_tcpa_disclosure_form">
  <label for="leadid_tcpa_disclosure_form" class="disclosure-text">
    @if (form.value.propertyState !== 'NY') {
      <span>*By entering my number and clicking the button above, I am electronically signing this web-form and giving my <strong>express written consent</strong> for FreeRateUpdate.com LLC and its <a href="/approved-lenders" target="_blank" rel="nofollow noopener noreferrer">network of lenders, mortgage brokers, and agents/assigns</a> that may call or text on behalf of those companies to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgage/home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of voice calls and SMS/MMS messages that are dialed manually or by using an automatic telephone dialing system, and prerecorded, artificial or AI-generated voice messages. Message and data rates may apply. I can call 855-315-7283 for help and text STOP to cancel. I acknowledge that consent is not required as a condition to utilize the services of FreeRateUpdate.com LLC or any of its network of lenders, mortgage brokers, and agents and that I may instead choose to use those services by calling 855-315-7283.</span>
    }
    @if (form.value.propertyState === 'NY') {
      <span>*By entering my number and clicking the button above, I am electronically signing this web-form and giving my <strong>express written consent</strong> for FreeRateUpdate.com LLC, including its network members LoanDepot, Rocket Mortgage, <a href="/approved-lenders" target="_blank" rel="nofollow noopener noreferrer"> and other lenders, mortgage brokers, and agents/assigns</a> that may call or text on behalf of those companies to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgage/home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of voice calls and SMS/MMS messages that are dialed manually or by using an automatic telephone dialing system, and prerecorded, artificial or AI-generated voice messages. Message and data rates may apply. I can call 855-315-7283 for help and text STOP to cancel. I acknowledge that consent is not required as a condition to utilize the services of FreeRateUpdate.com LLC or any of its network of lenders, mortgage brokers, and agents and that I may instead choose to use those services by calling 855-315-7283.</span>
    }

    <br/><br/>
    I also agree to and am electronically signing FreeRateUpdate.com's <a href="/privacy" target="_blank" rel="nofollow noopener noreferrer">Privacy Policy</a> and its <a href="/terms" rel="nofollow noopener noreferrer" target="_blank">Terms and Conditions</a>.
  </label>
</p>
